
import { defineComponent } from 'vue';
import TheFooter from '@/components/organisms/TheFooter.vue';

export default defineComponent({
  name: 'General',
  components: { TheFooter },
});
